module.exports = __webpack_public_path__ + "img/duihao2.28ac4b57.png";